import React, { useEffect, useRef, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import styles from './../../Assets/CSS/Style.module.css';
import inputStyles from './../../Assets/CSS/Input.module.css';
import { SmButton } from './../../Components/Button'; 
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import { FaCircleUser } from 'react-icons/fa6';
import { FaRegFolderOpen } from 'react-icons/fa';
import Info from './Info';

function Profile() {
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [details, setDetails] = useState([]);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [dob, setDoB] = useState('');
    const [gender, setGender] = useState('');
    const [education, setEducation] = useState('');
    const [blood_group, setBloodGroup] = useState('');    
    const [house_no, setHouseNo] = useState('');
    const [road_name, setRoadName] = useState('');     
    const [pincode, setPincode] = useState('');
    const [district, setDistrict] = useState('');
    const [state, setState] = useState('');
    const [country, setCountry] = useState(''); 
    const [landmark, setLandmark] = useState('');  
    const [aadhaar_no, setAadhaarNo] = useState(''); 
    const [ads, setAds] = useState([]); 
    useEffect(() => {
        document.title = 'Infomart | Client Profile';
        fetchUserDetails(); 
        axios.get(`${BASE_URL}/ads`, {
            headers: {  
                'Content-Type': 'application/json' 
            } 
        }).then((res) => {
            setAds(res.data.data); 
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 }); 
        });      
    }, []);
    const fetchUserDetails = () => {
        setIsLoading(true);
        axios.get(`${BASE_URL}/vendor/details`, {
            headers: { 
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setDetails(res.data.data);
            setName(res.data.data.name);
            setEmail(res.data.data.email);
            setPhone(res.data.data.phone);
            setWhatsapp(res.data.data.whatsapp);
            setDoB(res.data.data.dob);
            setGender(res.data.data.gender);
            setEducation(res.data.data.education); 
            setBloodGroup(res.data.data.blood_group);  
            setHouseNo(res.data.data.house_no);
            setRoadName(res.data.data.road_name); 
            setPincode(res.data.data.pincode);
            setDistrict(res.data.data.district);
            setState(res.data.data.state);
            setCountry(res.data.data.country); 
            setLandmark(res.data.data.landmark); 
            setAadhaarNo(res.data.data.aadhaar_no); 
            setIsLoading(false); 
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }
    const handlePincode = (e) => {
        let value = e.target.value;
        setPincode(value); 
        if (value.length == 6) {
            axios.get(`${BASE_URL}/pincode/${value}`).then((res) => { 
                setDistrict(res.data[0].PostOffice[0].District);
                setState(res.data[0].PostOffice[0].State);
                setCountry(res.data[0].PostOffice[0].Country); 
            });    
        }
    }   
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const handleUpdate = async () => {
        setIsUpdateLoading(true);
        await axios.post(`${BASE_URL}/vendor/update-profile`, { name, whatsapp, dob, gender, education, blood_group, house_no, road_name, pincode, district, state, country, landmark, aadhaar_no }, {
            headers: {   
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }  
        }).then((res) => {
            fetchUserDetails();
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsUpdateLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsUpdateLoading(false);
        });
    }
    const [current_password, setCurrentPassword] = useState('');
    const [new_password, setNewPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    const [isChangeLoading, setIsChangeLoading] = useState(false);
    const handleChange = async () => {
        setIsChangeLoading(true);
        await axios.post(`${BASE_URL}/vendor/change-password`, { current_password, new_password, confirm_password }, {
            headers: { 
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsChangeLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsChangeLoading(false);
        });
    }
    const inputRef = useRef();
    const handleSelectFile = () => {
        inputRef.current.click();
    }
    const [profilePhotoPreview, setProfilePhotoPreview] = useState('');
    const [upload_image, setUploadImage] = useState(''); 
    const handleChangeProfilePicture = (e) => {
        const reader = new FileReader();
        const file = e.target.files[0];
        if (file) {
            reader.onloadend = () => {
                setProfilePhotoPreview(reader.result);
            };
            reader.readAsDataURL(file);
            setUploadImage(file);  
        }
    }
    const [isChangeImageLoading, setIsChangeImageLoading] = useState(false);
    const handleChangeImage = async () => {
        setIsChangeImageLoading(true);
        if (profilePhotoPreview) {
            const formData = new FormData();  
            formData.append('file', upload_image);    
            await axios.post(`${BASE_URL}/vendor/update-image`, formData, {
                headers: {    
                    'Content-Type': 'multipart/form-data',  
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                fetchUserDetails();
                toast.success(res.data.msg, { autoClose: 3000 });
                setIsChangeImageLoading(false);
            }).catch((res) => {
                toast.error(res.response.data.msg, { autoClose: 3000 });
                setIsChangeImageLoading(false);
            });
        } else {
            toast.error('Select your image first.', { autoClose: 3000 });
            setIsChangeImageLoading(false);   
        }  
    }
    const handleDateChange = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, '');
        if (value.length > 8) {
            value = value.substring(0, 8);
        }
        if (value.length >= 5) {
            value = value.replace(/^(\d{2})(\d{2})(\d{0,4})$/, '$1/$2/$3');
        } else if (value.length >= 3) {
            value = value.replace(/^(\d{2})(\d{0,2})$/, '$1/$2');
        }
        setDoB(value);
    }; 
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />  
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                    : 
                        <div className={styles.profilePageContainer}>
                            <div className={styles.leftSection}>
                                <h4 className="mb-0">Hello, {details.name}</h4>
                                <div className={styles.accountDetailsBox}>
                                    <div className={styles.boxHead}>Profile Photo</div>
                                    <div className={styles.accountDetailsInner}>
                                        <div className={styles.fileInputContainer}>
                                            {profilePhotoPreview ?
                                                <>
                                                    <div className={styles.profilePicContainer}>
                                                        <img src={profilePhotoPreview} className={styles.profilePic} />
                                                    </div>
                                                    <SmButton title={"Browse"} leftIcon={<FaRegFolderOpen />} onClick={() => handleSelectFile()} />
                                                </>
                                                :
                                                <>
                                                    {details.image ?
                                                        <>
                                                            <div className={styles.profilePicContainer}>
                                                                <img src={BASE_FILE_URL + details.image} className={styles.profilePic} />
                                                            </div>
                                                            <SmButton title={"Browse"} leftIcon={<FaRegFolderOpen />} onClick={() => handleSelectFile()} />
                                                        </>
                                                        :
                                                        <>
                                                            <FaCircleUser size={52} color="gray" />
                                                            <div className="text-muted fs-6">Click to Select</div>
                                                            <SmButton title={"Browse"} leftIcon={<FaRegFolderOpen />} onClick={() => handleSelectFile()} />
                                                        </>
                                                    }
                                                </>
                                            }
                                        </div>
                                        <input type="file" ref={inputRef} className={styles.file} accept="image/*" onChange={(e) => handleChangeProfilePicture(e)} />
                                    </div>
                                    <div className={styles.btnContainer}>
                                        <SmButton title={isChangeImageLoading ? "Loading..." : "Change"} onClick={() => handleChangeImage()} />
                                    </div>
                                </div>
                                <div className={styles.accountDetailsBox}>
                                    <div className={styles.boxHead}>Personal Details</div>
                                    <div className={styles.accountDetailsInner}>
                                        <div className={styles.inputs}>
                                            <input type="text" className={inputStyles.input} value={name} placeholder="Enter Your Full Name *" onChange={e => setName(e.target.value)} />
                                            <input type="email" className={inputStyles.input} value={email} readOnly />
                                            <input type="number" className={inputStyles.input} value={phone} readOnly />
                                            <input type="number" className={inputStyles.input} value={whatsapp} placeholder="Enter WhatsApp No. *" onChange={e => setWhatsapp(e.target.value)} />
                                            <select className={inputStyles.dropdown} value={blood_group} onChange={e => setBloodGroup(e.target.value)}>  
                                                <option value="" selected disabled>Select Blood Group</option>
                                                <option value="A+">A+</option>  
                                                <option value="A-">A-</option>
                                                <option value="B+">B+</option>
                                                <option value="B-">B-</option>
                                                <option value="AB+">AB+</option>
                                                <option value="AB-">AB-</option>
                                                <option value="O+">O+</option>
                                                <option value="O-">O-</option> 
                                            </select>
                                            <input type="text" className={inputStyles.input} value={dob} placeholder="Enter Date of Birth (DD/MM/YYYY) *" onChange={handleDateChange} /> 
                                            <select className={inputStyles.dropdown} value={gender} onChange={e => setGender(e.target.value)}> 
                                                <option value="Male">Male</option>  
                                                <option value="Female">Female</option>
                                            </select>
                                            <input type="text" className={inputStyles.input} value={education} placeholder="Enter Education *" onChange={e => setEducation(e.target.value)} />
                                            <input type="text" className={inputStyles.input} value={house_no} placeholder="Enter House No." onChange={e => setHouseNo(e.target.value)} />
                                            <input type="text" className={inputStyles.input} value={road_name} placeholder="Enter Road Name *" onChange={e => setRoadName(e.target.value)} />
                                            <input type="number" className={inputStyles.input} value={pincode} placeholder="Enter Pincode *" onChange={handlePincode} />
                                            <input type="text" className={inputStyles.input} value={district} placeholder="Enter District *" onChange={e => setDistrict(e.target.value)} /> 
                                            <input type="text" className={inputStyles.input} value={state} placeholder="Enter State *" onChange={e => setState(e.target.value)} />
                                            <input type="text" className={inputStyles.input} value={country} placeholder="Enter Country *" onChange={e => setCountry(e.target.value)} />
                                            <textarea className={inputStyles.input} value={landmark} placeholder="Enter Landmark (Optional)" onChange={e => setLandmark(e.target.value)} />
                                            <input type="number" className={inputStyles.input} value={aadhaar_no} placeholder="Enter Aadhaar No. *" onChange={e => setAadhaarNo(e.target.value)} />
                                        </div> 
                                        <div>
                                            <SmButton title={isUpdateLoading ? "Loading..." : "Update"} onClick={() => handleUpdate()} />
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.accountDetailsBox}>
                                    <div className={styles.boxHead}>Change Password</div>
                                    <div className={styles.accountDetailsInner}>
                                        <div className={styles.inputs}>
                                            <input type="password" className={inputStyles.input} value={current_password} placeholder="Current Passoword *" onChange={e => setCurrentPassword(e.target.value)} />
                                            <input type="password" className={inputStyles.input} value={new_password} placeholder="New Passoword *" onChange={e => setNewPassword(e.target.value)} />
                                            <input type="password" className={inputStyles.input} value={confirm_password} placeholder="Confirm Password *" onChange={e => setConfirmPassword(e.target.value)} />
                                        </div>
                                        <div>
                                            <SmButton title={isChangeLoading ? "Loading..." : "Change"} onClick={() => handleChange()} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.rightSection}>
                                <div className={styles.adImgContainer}>
                                    <img src={BASE_FILE_URL + ads[0]?.image} />
                                </div>
                                <div className={styles.adImgContainer}>
                                    <img src={BASE_FILE_URL + ads[1]?.image} />
                                </div> 
                            </div>
                        </div>
                    }
                </div>
            </div> 
        </div>
    );
}

export default Profile; 